// Foundations
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {

  getDirectionsUrl(destination): string {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(destination);
  }

}
